<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">基本信息</div>
      </div>
      <div v-if="type != 'add'">
        <span>走访任务单编号：</span>
        <span>{{ form.bizNo }}</span>
      </div>
    </div>

    <el-form :model="form" ref="form" :rules="rules" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item label="果园编号">
            <el-input disabled v-model="form.plantationNo"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item label="果园名称">
            <el-input disabled v-model="form.plantationName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item label="果园区域">
            <el-input disabled v-model="form.locName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item label="园主/场长">
            <el-input disabled v-model="form.ownerName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item label="联系方式">
            <el-input disabled v-model="form.ownerContact"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item
            label="品控人员"
            prop="qcOperatorIds"
          >
            <el-select
              v-model="form.qcOperatorIds"
              multiple
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in observeList"
                :key="item.userId"
                :label="item.userName"
                :value="item.userId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item 
            label="走访截止日期"
            prop="visitDueDate"
          >
            <el-date-picker v-model="form.visitDueDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" :xs="12">
          <el-form-item label="走访要求">
            <el-input
              :rows="3"
              resize="none"
              type="textarea"
              maxlength="300"
              v-model="form.visitRequirementDesc"
              placeholder="300字以内"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { modifyTask, getTaskDetail } from '@/api/system/manage'
import { userByRoleList } from '@/api/system/system'

export default {
  data() {
    return {
      form: {
        bizNo: '',
        bizType: 0,
        visitDueDate: '',
        qcOperatorIds: [],
        visitRequirementDesc: '',
      },
      observeList: [],
      rules: {
        qcOperatorIds: [{ required: true, message: '请选择品控人员', trigger: ['blur','change'] }],
        visitDueDate: [{ required: true, message: '请选择日期', trigger: 'blur' }],
      }
    }
  },
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  created() {
    this.getUserByRoles()
  },
  methods: {
    getUserByRoles(){
      userByRoleList({roleName: '品控员'}).then(res => {
        if (res.flag) {
          this.observeList = res.data.map(item=>{
            item.userId = item.id
            delete item.id
            return item
          })
        }
      })
    },
    getDetails(row){
      if(row){
        if(this.type == 'edit'){
          this.getTaskInfo(row.id)
        }else{
          this.form = Object.assign(this.form,{
            ...row,
            plantationId: row.id,
            plantationNo: row.bizNo,
            plantationName: row.name
          })
          delete this.form.createTime
          delete this.form.updateTime
          delete this.form.createBy
          delete this.form.createId
          delete this.form.updateBy
          delete this.form.updateId
          delete this.form.tenantId
          delete this.form.delFlag
          delete this.form.remark
          delete this.form.status
          delete this.form.bizNo
          delete this.form.id
        }
      }
    },
    getTaskInfo(id){
      getTaskDetail(id).then(res => {
        if (res.flag) {
          this.form = {
            ...res.data,
            locName: this.formatLocal(res.data.locDetails, 3),
            qcOperatorIds: res.data.qcOperators.map(item=>item.userId)
          }
        }
      })
    },
    submit(){
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            let qcOperators = []
            this.form.qcOperatorIds.forEach(d=>{
              let obs = this.observeList.find(o=>o.userId == d)
              qcOperators.push(obs)
            })
            this.form.qcOperators = qcOperators
            let result = await modifyTask(this.form, this.type)
            if(result.code == 200 && result.flag){
              this.$message.success('提交成功')
              resolve()
            }else{
              this.$message.error(result.message)
              reject()
            }
          } else {
            reject()
          }
        })
      })
    },
    reset(){
      this.form = {
        bizType: 0,
        qcOperatorIds: [],
        visitRequirementDesc: '',
      }
      this.resetForm('form')
    },
  },
}
</script>

<style scoped lang='less'>
@import '../../../../assets/form.less';
/deep/ .el-select, .el-date-editor {
  width: 100%;
}
</style>